import {Action, Dispatch} from 'redux';
import configAPI from '../APIs/configAPI';

const TYPES = {
    FETCH_MAINTENANCE_TIME_SUCCESS: 'FETCH_MAINTENANCE_TIME_SUCCESS'
};

const fetchMaintenanceTime = () => {
    return function (dispatch: Dispatch<Action>) {
        return configAPI.maintenanceTime().then(res => {
            dispatch(storeMaintenanceTime(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const storeMaintenanceTime = (data: object) => {
    return {
        type: TYPES.FETCH_MAINTENANCE_TIME_SUCCESS,
        maintenanceTime: data
    };
};

export {TYPES, fetchMaintenanceTime};


// WEBPACK FOOTER //
// ./src/ReduxRequests/Actions/configAction.ts